import { eeEnvVariables } from '@/utilities/constants';
import * as microsoftTeams from '@microsoft/teams-js';
import Keycloak from 'keycloak-js';
import { useCallback } from 'react';

// Helper for extracting username from Teams token (AAD Access Token)
function extractUsernameFromTeamsToken(token: string): string | null {
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    return payload.preferred_username || payload.upn || payload.name || null;
  } catch {
    return null;
  }
}

export function useKeycloakInit() {
  const initialize = async (teamsToken: string) => {
    // 1️⃣ Extract username from Teams token (UPN)
    const username = extractUsernameFromTeamsToken(teamsToken);

    const keycloak = new Keycloak({
      url: eeEnvVariables.AUTH_URL,
      realm: eeEnvVariables.REALM_NAME,
      clientId: eeEnvVariables.CLIENT_ID,
    });

    try {
      const authenticated = await keycloak.init({
        enableLogging: true,
        checkLoginIframe: false,
      });

      if (authenticated) {
        // 2️⃣ Save token as secure cookie
        // sessionStorage.setItem('hm_kc_token', JSON.stringify(keycloak));
        sessionStorage.setItem('hm_auth_token', keycloak?.token?.toString() ?? '');

        return keycloak;
      } else {
        console.log('✔ Login part: else part');
        // 3️⃣ If not authenticated → login with username hint
        await keycloak.login({
          redirectUri: window.location.origin + window.location.pathname,
          loginHint: username ?? undefined, // <-- pass username from Teams
          idpHint: 'kfsaml',
          prompt: 'login', // your SAML provider
        });
      }
    } catch (err) {
      console.error('Keycloak initialization failed', err);
    }
  };

  return { initialize };
}
